import * as React from "react";
import FormInput from "./FormInput";
import InputProps from "../../../model/form/InputProps";
import { buildClasses } from "../../../utils/classes";
import Option from "../../../model/Option";
import InputState from "../../../model/form/InputState";

interface IconSelectionInputProps extends InputProps {
  options: Option[];
}

export default class IconSelectionInput extends React.Component<IconSelectionInputProps> {
  constructor(props: IconSelectionInputProps) {
    super(props);
    this.template = this.template.bind(this);
  }

  template(state: InputState, input) {
    return (
      <div
        className={buildClasses(
          { invalid: () => state.status.invalid && !state.status.pristine },
          "input-group"
        )}
      >
        <label htmlFor={this.props.name}>
          <span>{this.props.label}</span>
          <span className="detail">{this.props.detail}</span>
        </label>
        <div className="group">
          {this.props.options.map((o) => (
            <label key={o.value}>
              <input
                type="radio"
                className="selectable-icon"
                name={this.props.name}
                id={o.value}
                onChange={input.change}
                onBlur={input.dirty}
                value={o.value}
                checked={state.value === o.value}
              />
              <i className={o.label + " clickable"} />
            </label>
          ))}
        </div>
        <div className="error-message">{state.status.errorMessage}</div>
      </div>
    );
  }

  render() {
    return <FormInput {...this.props} template={this.template} />;
  }
}
